import { useQuery } from "@tanstack/react-query"
import { client } from "@/api"
import type { SelectSubscriptionPlan } from "../../../backend/db/tables/subscription_plans"
import type { SelectSubscriptionPlanVersion } from "../../../backend/db/tables/subscription_plan_versions"

// Extend the backend type with admin-specific fields
interface SubscriptionPlan extends SelectSubscriptionPlan {
  sync_status?: "synced" | "pending" | "error" | "draft" | null
  needs_publish?: boolean
  // Entitled teams on this plan, split by what backs the access (countEntitledTeamsByPlan).
  team_counts?: { teams: number; comped: number; paying: number }
  versions: SubscriptionPlanVersion[]
}

// Use the backend type directly
type SubscriptionPlanVersion = SelectSubscriptionPlanVersion

interface SubscriptionPlansResponse {
  plans: SubscriptionPlan[]
}

export function useSubscriptionPlans() {
  return useQuery<SubscriptionPlansResponse>({
    queryKey: ["admin", "subscription-plans"],
    queryFn: async () => {
      const response = await (client).admin["subscription-plans"].$get()

      if (!response.ok) {
        throw new Error(`Failed to fetch subscription plans: ${response.status}`)
      }

      return response.json()
    },
  })
}

export type { SubscriptionPlan, SubscriptionPlanVersion, SubscriptionPlansResponse }
